import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardsRoutes } from './dashboards.routing';
import { FactoringComponent } from './factoring/factoring.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxFileDropModule } from 'ngx-file-drop';
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { NgxDocViewerModule} from 'ngx-doc-viewer';
import {
  CommonModule,
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from '@angular/common';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { ClientsComponent } from './clients/clients.component';
import { MatCardModule } from '@angular/material/card';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from 'src/app/material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltersComponent } from './clients/components/filters/filters.component';
import localeEsCl from '@angular/common/locales/es-CL';
import loacleEsClExtra from '@angular/common/locales/extra/es-CL';
import { TablerIconsModule } from 'angular-tabler-icons';
import { RechargeUsersDirective } from './directives/recharge-users.directive';
import { InternalUsersComponent } from './internal-users/internal-users.component';
import { AddUsersComponent } from './internal-users/add-users/add-users.component';
import { DeletedUsersComponent } from './internal-users/deleted-users/deleted-users.component';
import { ModalAddComponent } from './internal-users/modal-add/modal-add.component';
import { ModalEditComponent } from './internal-users/modal-edit/modal-edit.component';
import { TableCompaniesComponent } from './factoring/components/table-companies/table-companies.component';
import { FactoringMonthlyAmountComponent } from './factoring/components/factoring-monthly-amount/factoring-monthly-amount.component';
import { FactoringFactorizationsComponent } from './factoring/components/factoring-factorizations/factoring-factorizations.component';
import { FactoringDocsComponent } from './factoring/components/factoring-docs/factoring-docs.component';
import { FiltersFactoringComponent } from './factoring/components/filters/filters-factoring.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from 'src/app/services/token.interceptor';
import { CdkMenuModule } from '@angular/cdk/menu';
import { FilesClientsComponent } from './files-clients/files-clients.component';
import { InformationComponent } from './files-clients/components/information/information.component';
import { FactDocsClientComponent } from './files-clients/components/fact-docs-client/fact-docs-client.component';
import { FiltersFilesClientsComponent } from './files-clients/components/filters-files-clients/filters-files-clients.component';
import { DebtorInformationComponent } from './files-clients/components/debtor-information/debtor-information.component';
import { TableMinutesComponent } from './files-clients/components/table-minutes/table-minutes.component';
import { PurchaseOrderComponent } from './files-clients/modals/purchase-order/purchase-order.component';
import { MinutesComponent } from './files-clients/sub-page/minutes/minutes.component';
import { LineDetailChartComponent } from './files-clients/components/line-detail-chart/line-detail-chart.component';
import { MatInputModule } from '@angular/material/input';
import { MinutesDebtorsComponent } from './files-clients/sub-page/components/minutes-debtors/minutes-debtors.component';
import { PartnerTableComponent } from './files-clients/components/partner-table/partner-table.component';
import { OperationModalComponent } from './files-clients/modals/operation-modal/operation-modal.component';
import { InvoiceOperationsComponent } from './files-clients/components/invoice-operations/invoice-operations.component';
import { MatSliderModule } from '@angular/material/slider';
import { MinuteResolutionItemComponent } from './files-clients/sub-page/components/minute-resolution-item/minute-resolution-item.component';
import { MinuteDebtorCompanyResolutionsComponent } from './files-clients/sub-page/components/minute-debtor-company-resolutions/minute-debtor-company-resolutions.component';
import { MinuteFactoringFactorizationComponent } from './files-clients/sub-page/components/minute-factoring-factorization/minute-factoring-factorization.component';
import { MinutesOwnersComponent } from './files-clients/sub-page/components/minutes-owners/minutes-owners.component';
import { MinuteTopDebtorsComponent } from './files-clients/sub-page/components/minute-top-debtors/minute-top-debtors.component';
import { RegisterMinutesComponent } from './files-clients/modals/register-minutes/register-minutes.component';
import { ChangeMinuteRequestLineModalComponent } from './files-clients/sub-page/components/change-minute-request-line-modal/change-minute-request-line-modal.component';
import {
  IConfig,
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
  provideNgxMask,
} from 'ngx-mask';
import { ModalCommentComponent } from './modals/modal-comment/modal-comment.component';
import { TgrFormComponent } from './files-clients/components/forms/tgr-form/tgr-form.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CmfFormComponent } from './files-clients/components/forms/cmf-form/cmf-form.component';
import { FormularioFacturaFormulaComponent } from './files-clients/modals/formulario-factura-formula/formulario-factura-formula.component';
import { DetalleTgrComponent } from './files-clients/components/information/detalle-tgr/detalle-tgr.component';
import { DetalleCmfComponent } from './files-clients/components/information/detalle-cmf/detalle-cmf.component';
import { DicomFormularioComponent } from './files-clients/modals/dicom-formulario/dicom-formulario.component';
import { DetalleIngeAdmComponent } from './files-clients/components/information/detalle-inge-adm/detalle-inge-adm.component';
import { TableDummyComponent } from './files-clients/sub-page/components/table-dummy/table-dummy.component';
import { MatSortModule } from '@angular/material/sort';
import { AprobacionesMinutaComponent } from './files-clients/modals/aprobaciones-minuta/aprobaciones-minuta.component';
import { DetalleFogapeComponent } from './files-clients/components/information/detalle-fogape/detalle-fogape.component';
import { CustomDatePipe } from 'src/app/pipe/date.pípe';
import { RutChilenoDvPipe } from './../../pages/dashboards/warranties/view-deals-evaluations/shared/rut-chileno-dv.pipe'
import { PdfComponent } from './files-clients/sub-page/components/pdf/pdf.component';
import { MinuteOperationsListComponent } from './files-clients/sub-page/components/minute-operations-list/minute-operations-list.component';
import { RegisterMinuteWithOpsComponent } from './files-clients/modals/register-minute-with-ops/register-minute-with-ops.component';
import { ModificarDescripcionComponent } from './files-clients/modals/modificar-descripcion/modificar-descripcion.component';
import { UpdateInformationComponent } from './files-clients/modals/update-information/update-information.component';
import { UpdateOwnersComponent } from './files-clients/modals/update-owners/update-owners.component';
import { DetalleFactVComponent } from './files-clients/components/information/detalle-fact-v/detalle-fact-v.component';
import { ClientCreditNotesTableComponent } from './files-clients/components/client-credit-notes-table/client-credit-notes-table.component';
import { DetalleOperationsComponent } from './files-clients/components/information/detalle-operations/detalle-operations.component';
import { ClientBuyInvoicesComponent } from './files-clients/components/client-buy-invoices/client-buy-invoices.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CompanyAssignmentsPortfolioUserComponent } from './portfolio/components/company-assignments-portfolio-user/company-assignments-portfolio-user.component';
import { PortfolioFilterSectionComponent } from './portfolio/components/portfolio-filter-section/portfolio-filter-section.component';
import { AddClientModalComponent } from './factoring/modals/add-client-modal/add-client-modal.component';
import { InvoiceOperationCalculationFormComponent } from './invoice-operations/invoice-operation-calculation-form/invoice-operation-calculation-form.component';
import { UpdateInvoiceOperationModalComponent } from './invoice-operations/update-invoice-operation-modal/update-invoice-operation-modal.component';
import { QrMinuteComponent } from './files-clients/sub-page/components/qr-minute/qr-minute.component';
import { ViewMinutesComponent } from './view-minutes/view-minutes.component';
import { MinutesTableComponent } from './view-minutes/minutes-table/minutes-table.component';
import { FiltersMinuteTableComponent } from './view-minutes/filters-minute-table/filters-minute-table.component';
import { ClientDebtorRelationshipModalComponent } from './files-clients/modals/client-debtor-relationship-modal/client-debtor-relationship-modal.component';
import { ClientToDebtorRelationshipSummaryComponent } from './files-clients/components/client-to-debtor-relationship-summary/client-to-debtor-relationship-summary.component';
import { InvoceSellFactoringComponent } from './files-clients/components/invoce-sell-factoring/invoce-sell-factoring.component';
import { ClientCesionariosTableComponent } from './files-clients/components/client-cesionarios-table/client-cesionarios-table.component';
import { GeneralTableComponent } from './../../common/components/general-table/general-table.component';
import { ModalLoadingFileClientsComponent } from './modals/modal-loading-file-clients/modal-loading-file-clients.component';
import { ModalUpdateInvocesComponent } from './modals/modal-update-invoces/modal-update-invoces.component';
import { MinuteWarrantiesComponent } from './files-clients/sub-page/components/minute-warranties/minute-warranties.component';
import { WarrantiesComponent } from './warranties/warranties.component';
import { TableIssueWarrantiesComponent } from './warranties/components/table-issue-warranties/table-issue-warranties.component';
import { WarrantyFilterSectionComponent } from './warranties/components/warranty-filter-section/warranty-filter-section.component';
import { DebtorsFavoriteComponent } from './clients/components/debtors-favorite/debtors-favorite.component';
import { TableDebtorFavoriteComponent } from './clients/components/debtors-favorite/table-debtor-favorite/table-debtor-favorite.component';
import { FilterDebtorFavoriteComponent } from './clients/components/debtors-favorite/filter-debtor-favorite/filter-debtor-favorite.component';
import { DebtorBlackListComponent } from './clients/components/debtor-black-list/debtor-black-list.component';
import { TableDebtorBlackListComponent } from './clients/components/debtor-black-list/table-debtor-black-list/table-debtor-black-list.component';
import { FilterDebtorBlackListComponent } from './clients/components/debtor-black-list/filter-debtor-black-list/filter-debtor-black-list.component';
import { FutureFeatureComponent } from './future-feature/future-feature.component';
import { FormulaViewComponent } from './formula-view/formula-view.component';
import { FormulaCesionarioTableComponent } from './formula-view/components/formula-cesionario-table/formula-cesionario-table.component';
import { AllDebtorsComponent } from './clients/components/all-debtors/all-debtors.component';
import { AllDebtorsTableComponent } from './clients/components/all-debtors/all-debtors-table/all-debtors-table.component';
import { AllDebtorsFilterComponent } from './clients/components/all-debtors/all-debtors-filter/all-debtors-filter.component';
import { AddDebtorModalComponent } from './modals/add-debtor-modal/add-debtor-modal.component';
import { CompanysUnExecutiveComponent } from './clients/components/companys-un-executive/companys-un-executive.component';
import { CompanysUnExecutiveTableComponent } from './clients/components/companys-un-executive/companys-un-executive-table/companys-un-executive-table.component';
import { CompanysUnExecutiveFilterComponent } from './clients/components/companys-un-executive/companys-un-executive-filter/companys-un-executive-filter.component';
import { FormulaCompanyDetailComponent } from './formula-view/formula-company-detail/formula-company-detail.component';
import { ReceivedInvoicesTableComponent } from './formula-view/components/received-invoices-table/received-invoices-table.component';
import { CedidoInvoicesTableComponent } from './formula-view/components/cedido-invoices-table/cedido-invoices-table.component';
import { NewMinuteComponent } from './clients/components/new-minute/new-minute.component';
import { MinuteOwnersComponent } from './clients/components/new-minute/minute-owners/minute-owners.component';
import { FactoringFactComponent } from './clients/components/new-minute/factoring-fact/factoring-fact.component';
import { OperationListComponent } from './clients/components/new-minute/operation-list/operation-list.component';
import { DebtorsMinuteComponent } from './clients/components/new-minute/debtors-minute/debtors-minute.component';
import { ClientPendingWarrantiesTableComponent } from './files-clients/components/client-pending-warranties-table/client-pending-warranties-table.component';
import { WarrantiesMinuteComponent } from './clients/components/new-minute/warranties-minute/warranties-minute.component';
import { AddInvoiceOperationToMinuteModalComponent } from './clients/components/new-minute/add-invoice-operation-to-minute-modal/add-invoice-operation-to-minute-modal.component';
import { DebtorsMinutePdfComponent } from './clients/components/new-minute/debtors-minute-pdf/debtors-minute-pdf.component';
import { AddWarrantiesToMinuteModalComponent } from './clients/components/new-minute/add-warranties-to-minute-modal/add-warranties-to-minute-modal.component';

import { ChangeSIIPassComponent } from './modals/change-siipass/change-siipass.component';
import { FactoringFacPdfComponent } from './clients/components/new-minute/factoring-fac-pdf/factoring-fac-pdf.component';
import { MillionsFormatPipeService } from 'src/app/services/millions-format-pipe.service';
import { TgrFormDetalleComponent } from './files-clients/components/forms/tgr-form/tgr-form-detalle/tgr-form-detalle.component';
import { ModalUpdateDurationMinuteComponent } from './clients/components/new-minute/modals/modal-update-duration-minute/modal-update-duration-minute.component';
import { UploadCompanyDocsModalComponent } from './files-clients/modals/upload-company-docs-modal/upload-company-docs-modal.component';
import { CompanyDocumentsSectionComponent } from './files-clients/components/company-documents-section/company-documents-section.component';
import { FileManagementModule } from 'src/app/common/file-management/file-management.module';
import { DashboardClientsComponent } from './dashboard-clients/dashboard-clients.component';
import { MyCompaniesRegistredComponent } from './clients/my-companies-registred/my-companies-registred.component';
import { ListContactComponent } from './files-clients/components/information/sub-components/list-contact/list-contact.component';
import { AddNewContactComponent } from './files-clients/modals/add-new-contact/add-new-contact.component';
import { NotFound404Component } from './not-found404/not-found404.component';
import { ActivitySummaryChartComponent } from './files-clients/sub-page/components/activity-summary-chart/activity-summary-chart.component';
import { MatIconModule } from '@angular/material/icon';
import { ClientInfoComponent } from './clients/client-info/client-info.component';
import { ChanguePassClientComponent } from './clients/client-info/changue-pass-client/changue-pass-client.component';
import { UpdateInfoClientComponent } from './clients/client-info/update-info-client/update-info-client.component';
import { FilterDashboardClientComponent } from './dashboard-clients/filter-dashboard-client/filter-dashboard-client.component';
import { TableSellInvocesComponent } from './dashboard-clients/table-sell-invoces/table-sell-invoces.component';
import { TableBuyInvocesComponent } from './dashboard-clients/table-buy-invoces/table-buy-invoces.component';
import { PreviewCompanyDocumentModalComponent } from './files-clients/modals/preview-company-document-modal/preview-company-document-modal.component';
import { TopBuyInvocesComponent } from './dashboard-clients/top-buy-invoces/top-buy-invoces.component';
import { TopSellInvocesComponent } from './dashboard-clients/top-sell-invoces/top-sell-invoces.component';
import { FactoringOpportunitiesComponent } from './factoring-opportunities/factoring-opportunities.component';

import { PipeClientPipe } from './clients/components/pipe-client.pipe';
import { AbsoluteValuePipe } from 'src/app/common/absolute-value.pipe';

import { CompanyCorporateMeshModalComponent } from './files-clients/modals/company-corporate-mesh-modal/company-corporate-mesh-modal.component';
import { Unauthorized401Component } from './unauthorized401/unauthorized401.component';
import { UpdateWarrantyAmountModalComponent } from './warranties/modals/update-warranty-amount-modal/update-warranty-amount-modal.component';
import { CmfdealsComponent } from './files-clients/components/cmfdeals/cmfdeals.component';
import { ActivityComponent } from './files-clients/components/activity/activity.component';
import { ModalEventosComponent } from './modals/modal-eventos/modal-eventos.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import { DetailDealComponent } from './files-clients/components/cmfdeals/detail-deal/detail-deal.component';
import { CreateOperationsComponent } from './files-clients/components/invoice-operations/sub-componentes/create-operations/create-operations.component';
import { ApprovedOperationsComponent } from './files-clients/components/invoice-operations/sub-componentes/approved-operations/approved-operations.component';
import { MatChipsModule } from '@angular/material/chips';
import { ModalNewActivitiComponent } from './files-clients/components/cmfdeals/modal-new-activiti/modal-new-activiti.component';
import { ViewDealsEvaluationsComponent } from './warranties/view-deals-evaluations/view-deals-evaluations.component';
import { FilterTableDealsComponent } from './warranties/view-deals-evaluations/filter-table-deals/filter-table-deals.component';
import { TableDealsComponent } from './warranties/view-deals-evaluations/table-deals/table-deals.component';
import { MatRippleModule } from '@angular/material/core';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { ModalEditTagsDealsComponent } from './files-clients/components/cmfdeals/modal-edit-tags-deals/modal-edit-tags-deals.component';
import { ModalConstruccionWarrantieComponent } from './warranties/modal-construccion-warrantie/modal-construccion-warrantie.component';
import { ModalWarrantieIsBuildComponent } from './clients/components/new-minute/warranties-minute/modal-warrantie-is-build/modal-warrantie-is-build.component';
import { ViewDealsSimulationsComponent } from './warranties/view-deals-simulations/view-deals-simulations.component';
import { FilterTableSimulationsComponent } from './warranties/view-deals-simulations/filter-table-simulations/filter-table-simulations.component';
import { TableSimulationsComponent } from './warranties/view-deals-simulations/table-simulations/table-simulations.component';
import { SimulationStyleDirective } from './warranties/view-deals-simulations/simulation-style.directive';
import { DetailSimulationModalComponent } from './warranties/view-deals-simulations/modals/detail-simulation-modal/detail-simulation-modal.component';
import { ModalResolutionDiscountComponent } from './warranties/view-deals-simulations/modals/modal-resolution-discount/modal-resolution-discount.component';
import { ModalAccionResolutionComponent } from './warranties/view-deals-simulations/modals/modal-accion-resolution/modal-accion-resolution.component';
import { ViewSimulationsClientComponent } from './files-clients/sub-page/components/view-simulations-client/view-simulations-client.component';
import { DicountIconComponent } from './warranties/view-deals-simulations/styleIconClass/dicount-icon/dicount-icon.component';
import { ManageMinuteRequestConditionsModalComponent } from './clients/components/new-minute/modals/manage-minute-request-conditions-modal/manage-minute-request-conditions-modal.component';
import { RequestSignatureModalComponent } from './files-clients/modals/preview-company-document-modal/request-signature-modal/request-signature-modal.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

registerLocaleData(localeEsCl, 'es-CL', loacleEsClExtra);

@NgModule({
  imports: [
    RouterModule.forChild(DashboardsRoutes),
    NgxMaskDirective,
    NgxMaskPipe,
    FontAwesomeModule,
    PdfJsViewerModule,
    CommonModule,
    MatCardModule,
    NgApexchartsModule,
    MaterialModule,
    MatRippleModule,
    MatDatepickerModule,
    // MatNativeDateModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatMomentDateModule,
    MatFormFieldModule,
    FormsModule,
    MaterialModule,
    MatAutocompleteModule,
    TablerIconsModule,
    ReactiveFormsModule,
    MatInputModule,
    CdkMenuModule,
    MatCheckboxModule,
    MatSliderModule,
    MatSortModule,
    MaterialFileInputModule,
    GeneralTableComponent,
    FileManagementModule,
    NgxFileDropModule,
    MatIconModule,
    NgxDocViewerModule,
    NgxGraphModule,
    MatChipsModule,
    NgxExtendedPdfViewerModule,
  ],
  declarations: [
    ClientsComponent,
    CmfdealsComponent,
    ModalEventosComponent,
    AbsoluteValuePipe,
    CustomDatePipe,
    RutChilenoDvPipe,
    FiltersComponent,
    FactoringComponent,
    RechargeUsersDirective,
    InternalUsersComponent,
    AddUsersComponent,
    DeletedUsersComponent,
    ModalAddComponent,
    ModalEditComponent,
    TableCompaniesComponent,
    FactoringMonthlyAmountComponent,
    FactoringFactorizationsComponent,
    FactoringDocsComponent,
    FiltersComponent,
    ModalEditTagsDealsComponent,
    FiltersFactoringComponent,
    CreateOperationsComponent,
    FilesClientsComponent,
    InformationComponent,
    FactDocsClientComponent,
    FiltersFilesClientsComponent,
    DebtorInformationComponent,
    TableMinutesComponent,
    PurchaseOrderComponent,
    ApprovedOperationsComponent,
    ActivityComponent,
    MinutesComponent,
    LineDetailChartComponent,
    MinutesDebtorsComponent,
    PartnerTableComponent,
    MillionsFormatPipeService,
    OperationModalComponent,
    MinuteResolutionItemComponent,
    MinuteDebtorCompanyResolutionsComponent,
    InvoiceOperationsComponent,
    MinuteFactoringFactorizationComponent,
    MinutesOwnersComponent,
    MinuteTopDebtorsComponent,
    RegisterMinutesComponent,
    ChangeMinuteRequestLineModalComponent,
    ModalCommentComponent,
    TgrFormComponent,
    CmfFormComponent,
    FormularioFacturaFormulaComponent,
    DetalleTgrComponent,
    DetalleCmfComponent,
    DetalleIngeAdmComponent,
    DicomFormularioComponent,
    DetalleIngeAdmComponent,
    TableDummyComponent,
    AprobacionesMinutaComponent,
    DetalleFogapeComponent,
    PdfComponent,
    MinuteOperationsListComponent,
    RegisterMinuteWithOpsComponent,
    ModificarDescripcionComponent,
    UpdateInformationComponent,
    UpdateOwnersComponent,
    ClientCreditNotesTableComponent,
    DetalleFactVComponent,
    PortfolioComponent,
    ClientCreditNotesTableComponent,
    DetalleOperationsComponent,
    ClientBuyInvoicesComponent,
    CompanyAssignmentsPortfolioUserComponent,
    PortfolioFilterSectionComponent,
    AddClientModalComponent,
    InvoiceOperationCalculationFormComponent,
    UpdateInvoiceOperationModalComponent,
    QrMinuteComponent,
    ViewMinutesComponent,
    MinutesTableComponent,
    FiltersMinuteTableComponent,
    ClientDebtorRelationshipModalComponent,
    ClientToDebtorRelationshipSummaryComponent,
    InvoceSellFactoringComponent,
    ClientCesionariosTableComponent,
    ModalLoadingFileClientsComponent,
    ModalUpdateInvocesComponent,
    MinuteWarrantiesComponent,
    WarrantiesComponent,
    TableIssueWarrantiesComponent,
    WarrantyFilterSectionComponent,
    DebtorsFavoriteComponent,
    TableDebtorFavoriteComponent,
    FilterDebtorFavoriteComponent,
    DebtorBlackListComponent,
    TableDebtorBlackListComponent,
    FilterDebtorBlackListComponent,
    FutureFeatureComponent,
    FormulaViewComponent,
    FormulaCesionarioTableComponent,
    AllDebtorsComponent,
    AllDebtorsTableComponent,
    AllDebtorsFilterComponent,
    AddDebtorModalComponent,
    CompanysUnExecutiveComponent,
    CompanysUnExecutiveTableComponent,
    CompanysUnExecutiveFilterComponent,
    FormulaCompanyDetailComponent,
    ReceivedInvoicesTableComponent,
    CedidoInvoicesTableComponent,
    NewMinuteComponent,
    MinuteOwnersComponent,
    FactoringFactComponent,
    OperationListComponent,
    DebtorsMinuteComponent,
    ClientPendingWarrantiesTableComponent,
    WarrantiesMinuteComponent,
    AddInvoiceOperationToMinuteModalComponent,
    DebtorsMinutePdfComponent,
    ClientPendingWarrantiesTableComponent,    
    ChangeSIIPassComponent,
    AddWarrantiesToMinuteModalComponent,
    FactoringFacPdfComponent,
    TgrFormDetalleComponent,
    ModalUpdateDurationMinuteComponent,
    UploadCompanyDocsModalComponent,
    CompanyDocumentsSectionComponent,
    DashboardClientsComponent,
    MyCompaniesRegistredComponent,
    ListContactComponent,
    ActivitySummaryChartComponent,
    AddNewContactComponent,
    ClientInfoComponent,
    ChanguePassClientComponent,
    UpdateInfoClientComponent,
    FilterDashboardClientComponent,
    TableSellInvocesComponent,
    TableBuyInvocesComponent,
    PreviewCompanyDocumentModalComponent,
    TopBuyInvocesComponent,
    TopSellInvocesComponent,
    FactoringOpportunitiesComponent,
    PipeClientPipe,
    CompanyCorporateMeshModalComponent,
    Unauthorized401Component,
    UpdateWarrantyAmountModalComponent,
    DetailDealComponent,
    NotFound404Component,
    ModalNewActivitiComponent,
    ViewDealsEvaluationsComponent,
    FilterTableDealsComponent,
    TableDealsComponent,
    ModalConstruccionWarrantieComponent,
    ModalWarrantieIsBuildComponent,
    ViewDealsSimulationsComponent,
    FilterTableSimulationsComponent,
    TableSimulationsComponent,
    SimulationStyleDirective,
    DetailSimulationModalComponent,
    ModalResolutionDiscountComponent,
    ModalAccionResolutionComponent,
    ViewSimulationsClientComponent,
    DicountIconComponent,
    ManageMinuteRequestConditionsModalComponent,
    RequestSignatureModalComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    // provideEnvironmentNgxMask(maskConfig),
    // provideNgxMask(maskConfig),

    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
  exports: [
    CustomDatePipe,
    RutChilenoDvPipe,
    SimulationStyleDirective
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardsModule {}
